import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconPlaneComponent } from "./med-icon-plane.component";

@NgModule({
  declarations: [
    MedIconPlaneComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconPlaneComponent,
  ],
})
export class MedIconPlaneModule { }
